module.exports = __webpack_public_path__ + "media/Video 116.4f6b2ab8.mp4";